/* eslint-disable */
const improveBotRoute = process.env.REACT_APP_IMPROVEBOT_ROUTE || 'https://improve-bot.delightfulbush-65d4f852.westus3.azurecontainerapps.io/'
/* const improveBotRoute = process.env.REACT_APP_IMPROVEBOT_ROUTE || 'https://improvebot.krino.tech/' */

//const apisBackendRoute = process.env.REACT_APP_APIS_BACKEND_ROUTE || 'https://backend.krino.ai/'
const apisBackendRoute = process.env.REACT_APP_APIS_BACKEND_ROUTE || 'https://backend.krino.ai/'
/* const apisBackendRoute = process.env.REACT_APP_APIS_BACKEND_ROUTE || 'https://backend.krino.tech/' */

const chatCommerce = process.env.REACT_APP_CHAT_COMMERCE_ROUTE || 'https://chatcommerce.yellowpond-34aeb422.westus2.azurecontainerapps.io/'

const engineRoute = process.env.REACT_APP_ENGINE_ROUTE || 'https://motor-faaqs.delightfulbush-65d4f852.westus3.azurecontainerapps.io/'
/* const engineRoute = process.env.REACT_APP_ENGINE_ROUTE || 'https://engineprod-4edwgq22fa-ue.a.run.app/' */

const socketsRoute =  process.env.REACT_APP_SOCKETS_ROUTE || 'https://socket.krino.ai/'
/* const socketsRoute =  process.env.REACT_APP_SOCKETS_ROUTE || 'https://sockets.krino.tech/' */

const followUpRoute = process.env.REACT_APP_FOLLOWUP_ROUTE || 'https://follow-up.greenmeadow-9afc96be.westus2.azurecontainerapps.io/'
/* const followUpRoute = process.env.REACT_APP_FOLLOWUP_ROUTE || 'https://follow-up.krino.xyz/' */

const engineGPTRoute = process.env.REACT_APP_ENGINE_GPT_ROUTE || 'https://motor-custom.greenmeadow-579b49ff.westus2.azurecontainerapps.io/'

const motorJS = process.env.REACT_APP_MOTOR_JS_ROUTE || 'https://motor-js-cola.ambitiouscliff-ef14dc89.westus2.azurecontainerapps.io/'
// console.log({improveBotRoute,apisBackendRoute,engineRoute,socketsRoute})

// prod
// https://improve-bot.delightfulbush-65d4f852.westus3.azurecontainerapps.io/
// https://backend.krino.ai/botbuilder/
// https://tfn.krino.ai/
// https://socket-improve.krino.ai/

// testing
// https://improve-bot.delightfulbush-65d4f852.westus3.azurecontainerapps.io/
// https://backend.krino.ai/
// https://engine.krino.xyz/
// https://socket.krino.ai/

// utiliza las variables de entorno para conectarse a urls dinamicamente
export const apiUrl = (url, type = 'improve') => {
  let baseUrl = ''

  if (url[0] === '/') {
    url = url.slice(1)
  }

  if (type === 'improve') {
    baseUrl = improveBotRoute
  } else if (type === 'apisBackend') {
    console.log('url',url)
    baseUrl = apisBackendRoute
  } else if (type === 'engine') {
    baseUrl = engineRoute
  } else if (type === 'socket') {
    baseUrl = socketsRoute
  } else if (type === 'followUp') {
    baseUrl = followUpRoute
  } else if (type === 'motorJs') {
    console.log('motorJs')
    console.log(motorJS)
    baseUrl = motorJS
  } else if (type === 'engineGPT') {
    baseUrl = engineGPTRoute
  } else if (type === 'chatCommerce') {
    baseUrl = chatCommerce
  } else {
    console.error(`Para la ruta ${url} no se especificó un tipo válido`)
  }
  
  const finalUrl = baseUrl + url

  return finalUrl
}

